import { z } from "zod";
import { userOutputSchema } from "./users";

export const commentOutputSchema = z.object({
    id: z.number(),
    idempotencyKey: z.string(),
    comment: z.string(),
    taskId: z.number(),
    createdAt: z.date(),
    user: userOutputSchema,
});

export type CommentOutput = z.infer<typeof commentOutputSchema>;
